import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import connectUser from '../connectUser';
import Icon from '../ui/Icon';
import AppTile from '../ui/AppTile';
import { appsByCategory, accessState } from '../registry/selectors';
import { categoryLabel } from '../registry/categories';
import './screens.css';

function CategoryScreen({ userInfo }) {
  const history = useHistory();
  const { categoryId } = useParams();
  const routes = userInfo?.routes ? [...userInfo.routes] : [];
  const apps = appsByCategory(categoryId, routes);

  return (
    <div className="hive-container hive-screen">
      <button type="button" className="hive-backlink hive-tap" onClick={() => history.push('/store')}>
        <Icon name="ChevronLeft" size={18} /> Store
      </button>
      <h1 className="hive-h2 hive-screen-h">{categoryLabel(categoryId)}</h1>

      {apps.length === 0 ? (
        <div className="hive-empty"><p>No apps in this category yet.</p></div>
      ) : (
        <div className="hive-tile-grid">
          {apps.map((app) => (
            <AppTile
              key={app.id}
              app={app}
              state={accessState(app, routes)}
              onClick={() => history.push(`/apps/${app.id}`)}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default connectUser(CategoryScreen);
